import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsConsulComponent } from './simple-icons-consul.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsConsulComponent ],
    exports:      [ SimpleIconsConsulComponent ],
    bootstrap:    []
})
export class SimpleIconsConsulModule {}
